import { createApi } from '@/api/modules/utils'

const baseUrl = '/account/device'
const api = createApi(baseUrl)

// 在线设备相关
export const deviceApi = {
  list: api('list', 'get'),
  kick: api('kick', 'post'),
}
